import React from 'react'
import { Form } from 'react-bootstrap'
import style from './CustomInput.module.scss'
import classNames from 'classnames'

interface CustomLabelProps {
  show: boolean
  label?: string;
}
export const CustomLabel = (props: CustomLabelProps) => {
  return <Form.Label className={classNames(style.inputLabel, props.show ? 'visible' : 'invisible')}>{props?.label}</Form.Label>
}
